export default {"src":"/_next/static/media/copying-library-with-thonny.9969453c.gif","height":450,"width":600,"blurWidth":0,"blurHeight":0};